<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="6">
                <el-input placeholder="机构名称" v-model="name"></el-input>
            </el-col>
            <el-col :span="16">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="insName" label="机构名称">
            </el-table-column>
            <el-table-column prop="stayTime" label="停留时间">
                <template slot-scope="scope">
                    {{scope.row.stayTime}}<el-button style="margin-left: 15px;" @click="openEdit(scope.row,true)" type="text" size="small">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="stayRadius" label="停留半径">
                <template slot-scope="scope">
                    {{scope.row.stayRadius}}<el-button style="margin-left: 15px;" @click="openEdit(scope.row,false)" type="text" size="small">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>

        <el-dialog title="更新机构停留轨迹设置" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="forms" v-if="editType">
              <el-form-item label="停留时间(60~∞s)" prop="stayTime" label-width="140px">
                <el-input v-model.number="form.stayTime" type="number" min="60" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <el-form :model="form" :rules="rules2" ref="forms2" v-else>
                <el-form-item label="停留半径(5~500米)" prop="stayRadius" label-width="160px">
                  <el-input v-model.number="form.stayRadius" type="number" min="5" max="500" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="update">修 改</el-button>
            </div>
          </el-dialog>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    import axios from 'axios';
    export default {
        data() {
            return {
                name:'',
                data: [],
                dialogFormVisible:false,
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                editType:true,
                form: {
                    id:0,
                    insId:0,
                    stayTime: 0,
                    stayRadius:0,
                },
                rules: {
                    stayTime: [{ required: true, message: '请输入停留时间' },{type:'number',min:60,message:'停留时间应不小于 60s'}],
                },
                rules2: {
                    stayRadius: [{ required: true, message: '请输入停留半径' },{type:'number',min:5,max:500,message:'停留半径输入范围为5米至500米'}],
                },
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.name.trim() !='') {
                    params.name = this.name;
                }
                this.$http.get('/manage/trace/setting/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            openEdit(row,type) {
                this.dialogFormVisible = true;
                this.editType = type;
                this.form.id = row.id;
                this.form.insId = row.insId;
                this.form.stayTime = row.stayTime;
                this.form.stayRadius = row.stayRadius;
            },
            update() {
                if(this.editType) {
                    this.$refs['forms'].validate(this.handleForm);
                }else {
                    this.$refs['forms2'].validate(this.handleForm);
                }
            },
            handleForm(bool, obj) {
                if(bool) {
                    this.$http.post('/manage/trace/setting/update',this.form).then(rs=> {
                        if(rs.data.code == 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.dialogFormVisible = false;
                            this.getList();
                        }else {
                            this.dialogFormVisible = false;
                            this.$message({
                                message: rs.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            }
        },
        components: { Pagination }
    }
</script>